<mat-card>
    <table mat-table [dataSource]="reportRows()" data-qa="import-status-table">
        <ng-container matColumnDef="step">
            <th mat-header-cell *matHeaderCellDef>Prüfung</th>
            <td mat-cell *matCellDef="let element">
                <div class="flex">
                    @if (element.rowType === 'default') {
                        <mat-icon [class.feedback-primary]="element.isValid"
                                  [class.feedback-warn]="!element.isValid">
                            {{ element.stepIcon }}
                        </mat-icon>{{ element.stepName }}
                    } @else {
                        {{ element.stepName }}
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="limit">
            <th mat-header-cell *matHeaderCellDef>Grenzwert</th>
            <td mat-cell *matCellDef="let element">
                @if (element.rowType === 'default') {
                    @if (element.limitType === 'bruttoleistung-by-stadtwerke') {
                        {{ element.limit | leistungseinheit:Leistungseinheit.MW }}
                    } @else {
                        {{ element.limit }}
                    }
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef>Letzter Import</th>
            <td mat-cell data-qa="count-column" *matCellDef="let element"
                [class.feedback-warn]="!element.isValid">
                <div class="flex">
                    @if (element.rowType === 'default') {
                        @if (element.limitType === 'bruttoleistung-by-stadtwerke') {
                            {{ element.count | leistungseinheit:Leistungseinheit.MW }}
                        } @else {
                            {{ element.count }}
                        }
                        @if (element.isValid) {
                            <mat-icon class="feedback-primary" svgIcon="innogy_picto_check"></mat-icon>
                        } @else {
                            <mat-icon class="feedback-warn">error</mat-icon>
                        }
                    }
                    @if (element.rowType === 'exceededBruttoleistung') {
                        {{ element.count | leistungseinheit:Leistungseinheit.MW }}
                    }
                    @if (element.rowType === 'ungueltigeAnlage') {
                        {{ element.count }}
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-card>
